export const CHECKPOINT_REPORT__COLUMNS = [
  {
    title: "Cylinder",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["cylinderNo"],
  },
  {
    title: "Reported At Factory",
  },
  {
    title: "Reported At Site",
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fieldTechnician", "name"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["supervisor", "name"],
  },
  {
    title: "Submitted At",
    sortArrow: true,
    sortBy: "date",
    address: ["submittedAt"],
  },
  {
    title: "dispatched site",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["lastWorkingStation"],
  },
  {
    title: "Completed By",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["doneBy"],
  },
  {
    title: "Completed At",
    sortArrow: true,
    sortBy: "date",
    address: ["doneAt"],
  },
];


export const CHECKPOINT_REPORT_FILTERS = [
  {
    name: "Field Technician",
    value: [["fieldTechnician", "id"]],
    label: [["fieldTechnician", "name"]],
  },
  {
    name: "Supervisor",
    value: [["supervisor", "id"]],
    label: [["supervisor", "name"]],
  },

];